import React from "react";
import AchievementCardSection4 from "./AchievementCardSection4";

const AchievementSection4 = () => {
  return (
    <div id="prize">
      <div className="amazing-service mt-40 bg-slate-50">
        <div className="amazing lg:p-16 text-center ">
          <h1 className="lg:text-6xl text-2xl font-medium text-blue-900 pt-20">
            ACHIEVEMENT{" "}
            <a className="underline decoration-orange-700 ">AWARDED </a> IN
            SCHOOL
          </h1>
          {/* <p className="m-8 text-2xl text-gray-600">
          
        </p> */}
        </div>
        <div className="amazing-content lg:mx-32">
          <AchievementCardSection4 row="top" />
          <AchievementCardSection4 row="bottom" />
        </div>
      </div>
    </div>
  );
};

export default AchievementSection4;
